import { useEffect } from 'react';

interface Props {
  onClose: (v?: boolean) => void;
}

export default function ReminderDialog({ onClose }: Props) {
  useEffect(() => {
    window.document.body.style.overflow = 'hidden';
  }, []);

  function handleClose() {
    window.document.body.style.overflow = '';
    onClose();
  }
  return (
    <div className="reminder-dialog d-flex-r ai-center jc-center">
      <div className="reminder-mask" />
      <div className="bw-100 reminder-center p-10">
        <div className="reminder-title-block d-flex-r ai-center jc-center p-10">
          <span className="font-size-20 font-widget-600 text-color-white">温馨提示</span>
          <img className="w-25 ml-5" src="/pic/logoPic.png" alt="" />
        </div>
        <div className="reminder-content d-flex-c ai-center jc-center">
          <div className="flex-1 bw-100 d-flex-c ai-center jc-center">
            <div className="bw-100 p-10 border-radius-8 font-size-14 line-height-25 text-color-white word-wrap">
              公安部提示：请勿将已登记您本人身份证信息的号卡用于诈骗等不合法行为，请勿将号卡进行转卖、租借他人使用，请及时挂失、注销已丢失号卡，保护个人信息安全。
              <span className="text-tips">涉嫌诈骗等违法犯罪行为等号码，实名登记机主需承担法律责任。</span>
            </div>
          </div>
          <div className="bw-100">
            <div
              className="confirm-btn bg-white pt-10 pb-10 d-flex-r ai-center jc-center m-10 border-radius-20 text-color-white"
              onClick={handleClose}
            >
              我已知晓，并承诺本人使用
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
